// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793590055624
      var cssReload = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  